// extracted by mini-css-extract-plugin
module.exports = {"facebook-sign-in-button":"facebook-sign-in-button_facebook-sign-in-button__AzFPX","social-sign-in-button__icon":"facebook-sign-in-button_social-sign-in-button__icon__K_0J1"};